import { MBV2CachedHoverEntree } from '@/models';
import Vue from 'vue';
import { Component, Prop } from 'vue-property-decorator';

@Component({
  name: 'CmgNutritionCalculatorMetricsSummary',
})
export default class CmgNutritionCalculatorMetricsSummary extends Vue {
  @Prop({ default: null, type: Object})
  hoveredEntree!: MBV2CachedHoverEntree | null;

  get hasNutrition(): boolean {
    return this.hoveredEntree && this.hoveredEntree.nutrition.tcal > 0 ? true : false;
  }

  get tcal(): string {
    return this.hasNutrition && this.hoveredEntree ? this.hoveredEntree.nutrition.tcal.toString() : '00';
  }

  get carb(): number {
    return this.hoveredEntree ? this.hoveredEntree.nutrition.carb : 0;
  }

  get prot(): number {
    return this.hoveredEntree ? this.hoveredEntree.nutrition.prot : 0;
  }

  get tfat(): number {
    return this.hoveredEntree ? this.hoveredEntree.nutrition.tfat : 0;
  }

  get currentNutrition(): any {
    return this.hoveredEntree ? this.hoveredEntree.nutrition : null;
  }
}
